import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, withCtx as _withCtx, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "vechile-details-list" }
const _hoisted_2 = { class: "form-block" }
const _hoisted_3 = { class: "label-block" }
const _hoisted_4 = { class: "label-block_label" }
const _hoisted_5 = { class: "input-block" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-lg-10" }
const _hoisted_8 = { class: "label-block" }
const _hoisted_9 = { class: "d-flex justify-content-between w-100 switch-container" }
const _hoisted_10 = { class: "label-block_label" }
const _hoisted_11 = { class: "switch-toggle" }
const _hoisted_12 = { for: "a" }
const _hoisted_13 = {
  key: 0,
  class: "switch-toggle__switch",
  "data-checked": "لا",
  "data-unchecked": "نعم"
}
const _hoisted_14 = {
  key: 1,
  class: "switch-toggle__switch",
  "data-checked": "No",
  "data-unchecked": "Yes"
}
const _hoisted_15 = { class: "label-block_question position-relative" }
const _hoisted_16 = { class: "tooltip-content" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("a", {
  class: "popper",
  "data-bs-trigger": "hover",
  placement: "right",
  "data-bs-toggle": "popover"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "icon-question-icon" })
  ])
], -1)
const _hoisted_18 = { class: "form-block" }
const _hoisted_19 = { class: "label-block" }
const _hoisted_20 = { class: "label-block_label" }
const _hoisted_21 = { class: "label-block_question position-relative" }
const _hoisted_22 = { class: "tooltip-content" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("a", {
  class: "popper",
  "data-bs-trigger": "hover",
  placement: "right",
  "data-bs-toggle": "popover"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "icon-question-icon" })
  ])
], -1)
const _hoisted_24 = { class: "input-block" }
const _hoisted_25 = { class: "row" }
const _hoisted_26 = { class: "col-lg-10" }
const _hoisted_27 = { class: "form-block" }
const _hoisted_28 = { class: "label-block" }
const _hoisted_29 = { class: "label-block_label" }
const _hoisted_30 = { class: "input-block" }
const _hoisted_31 = { class: "row" }
const _hoisted_32 = { class: "col-lg-10" }
const _hoisted_33 = { class: "form-block" }
const _hoisted_34 = { class: "label-block" }
const _hoisted_35 = { class: "label-block_label" }
const _hoisted_36 = { class: "input-block" }
const _hoisted_37 = { class: "row" }
const _hoisted_38 = { class: "col-lg-10" }
const _hoisted_39 = { class: "form-block estimated-block" }
const _hoisted_40 = { class: "label-block" }
const _hoisted_41 = { class: "label-block_label" }
const _hoisted_42 = { class: "label-block_question position-relative" }
const _hoisted_43 = { class: "tooltip-content" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("a", {
  class: "popper",
  "data-bs-trigger": "hover",
  placement: "right",
  "data-bs-toggle": "popover"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "icon-question-icon" })
  ])
], -1)
const _hoisted_45 = { class: "input-block" }
const _hoisted_46 = { class: "row" }
const _hoisted_47 = { class: "col-lg-10 position-relative currency-input-block" }
const _hoisted_48 = { class: "phAmount" }
const _hoisted_49 = { class: "form-block estimated-block" }
const _hoisted_50 = { class: "estimated-value" }
const _hoisted_51 = { class: "title" }
const _hoisted_52 = { class: "mb-0" }
const _hoisted_53 = { key: 0 }
const _hoisted_54 = { class: "desc" }
const _hoisted_55 = { class: "form-block" }
const _hoisted_56 = { class: "label-block" }
const _hoisted_57 = { class: "label-block_label" }
const _hoisted_58 = { class: "label-block_question position-relative" }
const _hoisted_59 = { class: "tooltip-content" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("a", {
  class: "popper",
  "data-bs-trigger": "hover",
  placement: "right",
  "data-bs-toggle": "popover"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "icon-question-icon" })
  ])
], -1)
const _hoisted_61 = { class: "input-block" }
const _hoisted_62 = { class: "row" }
const _hoisted_63 = { class: "col-lg-10" }
const _hoisted_64 = { class: "form-block" }
const _hoisted_65 = { class: "label-block" }
const _hoisted_66 = { class: "label-block_label" }
const _hoisted_67 = { class: "input-block" }
const _hoisted_68 = { class: "row" }
const _hoisted_69 = { class: "col-lg-10" }
const _hoisted_70 = { class: "form-block" }
const _hoisted_71 = { class: "label-block" }
const _hoisted_72 = { class: "label-block_label" }
const _hoisted_73 = { class: "input-block-phone" }
const _hoisted_74 = { class: "row" }
const _hoisted_75 = { class: "col-lg-10" }
const _hoisted_76 = { class: "form-block" }
const _hoisted_77 = { class: "label-block" }
const _hoisted_78 = { class: "label-block_label" }
const _hoisted_79 = { class: "input-block" }
const _hoisted_80 = { class: "row" }
const _hoisted_81 = { class: "col-lg-10" }
const _hoisted_82 = { class: "submit-btn text-md-end text-center" }
const _hoisted_83 = { class: "row" }
const _hoisted_84 = { class: "col-lg-10" }
const _hoisted_85 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_form, {
    ref: "ruleFormRef",
    model: _ctx.vehicle,
    "status-icon": "",
    rules: _ctx.rules,
    class: "demo-ruleForm"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("label", null, _toDisplayString(_ctx.$t('car_registration_year')) + " * ", 1)
            ])
          ]),
          (_ctx.isMobile)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_ctx.car_year_id)
                  ? (_openBlock(), _createBlock(_Teleport, {
                      key: 0,
                      to: `#${_ctx.car_year_id}`
                    }, [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.year_search,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.year_search) = $event)),
                        placeholder: "Search ..",
                        ref: "year_search_ref",
                        style: {"position":"absolute","top":"0px"}
                      }, null, 8, ["modelValue"])
                    ], 8, ["to"]))
                  : _createCommentVNode("", true),
                (_ctx.car_brand_id)
                  ? (_openBlock(), _createBlock(_Teleport, {
                      key: 1,
                      to: `#${_ctx.car_brand_id}`
                    }, [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.brand_search,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.brand_search) = $event)),
                        placeholder: "Search ..",
                        ref: "brand_search_ref",
                        style: {"position":"absolute","top":"0px"}
                      }, null, 8, ["modelValue"])
                    ], 8, ["to"]))
                  : _createCommentVNode("", true),
                (_ctx.car_model_id)
                  ? (_openBlock(), _createBlock(_Teleport, {
                      key: 2,
                      to: `#${_ctx.car_model_id}`
                    }, [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.model_search,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.model_search) = $event)),
                        placeholder: "Search ..",
                        ref: "model_search_ref",
                        style: {"position":"absolute","top":"0px"}
                      }, null, 8, ["modelValue"])
                    ], 8, ["to"]))
                  : _createCommentVNode("", true),
                (_ctx.car_trim_id)
                  ? (_openBlock(), _createBlock(_Teleport, {
                      key: 3,
                      to: `#${_ctx.car_trim_id}`
                    }, [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.trim_search,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.trim_search) = $event)),
                        placeholder: "Search ..",
                        ref: "trim_search_ref",
                        style: {"position":"absolute","top":"0px"}
                      }, null, 8, ["modelValue"])
                    ], 8, ["to"]))
                  : _createCommentVNode("", true),
                (_ctx.emirates_id)
                  ? (_openBlock(), _createBlock(_Teleport, {
                      key: 4,
                      to: `#${_ctx.emirates_id}`
                    }, [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.emirates_search,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.emirates_search) = $event)),
                        placeholder: "Search ..",
                        ref: "emirates_search_ref",
                        style: {"position":"absolute","top":"0px"}
                      }, null, 8, ["modelValue"])
                    ], 8, ["to"]))
                  : _createCommentVNode("", true),
                (_ctx.country_id)
                  ? (_openBlock(), _createBlock(_Teleport, {
                      key: 5,
                      to: `#${_ctx.country_id}`
                    }, [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.country_search,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.country_search) = $event)),
                        placeholder: "Search ..",
                        ref: "country_search_ref",
                        style: {"position":"absolute","top":"0px"}
                      }, null, 8, ["modelValue"])
                    ], 8, ["to"]))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_el_form_item, { prop: "car_year" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.vehicle.car_year,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.vehicle.car_year) = $event)),
                      filterable: !_ctx.isMobile,
                      placeholder: "Registration Year",
                      class: "select-input",
                      onChange: _ctx.resetAll,
                      "default-first-option": "",
                      "popper-class": {'car_year_teleport': _ctx.isMobile},
                      onClick: _ctx.alertYear
                    }, {
                      default: _withCtx(() => [
                        (_ctx.isMobile)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.filtered_year, (item, index) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: index,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          : _createCommentVNode("", true),
                        (!_ctx.isMobile)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.yearsList, (item, index) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: index,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "filterable", "onChange", "popper-class", "onClick"])
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["form-block form-block-transition", {'form-expand': _ctx.isShowBrandNew}])
        }, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("label", null, _toDisplayString(_ctx.$t('is_car_brand_new')), 1)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _withDirectives(_createElementVNode("input", {
                  id: "a",
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectedCheck) = $event)),
                  onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.handleCheck && _ctx.handleCheck(...args)))
                }, null, 544), [
                  [_vModelCheckbox, _ctx.selectedCheck]
                ]),
                _createElementVNode("label", _hoisted_12, [
                  (_ctx.language === 'ar')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13))
                    : (_openBlock(), _createElementBlock("div", _hoisted_14))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_el_tooltip, {
                class: "box-item",
                effect: "light"
              }, {
                content: _withCtx(() => [
                  _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.$t('is_car_brand_new_tool_tip')), 1)
                ]),
                default: _withCtx(() => [
                  _hoisted_17
                ]),
                _: 1
              })
            ])
          ])
        ], 2),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("label", { ref: "car_brand" }, _toDisplayString(_ctx.$t('car_brand')) + " * ", 513)
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createVNode(_component_el_tooltip, {
                class: "box-item",
                effect: "light"
              }, {
                content: _withCtx(() => [
                  _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.$t('car_brand_tool_tip')), 1)
                ]),
                default: _withCtx(() => [
                  _hoisted_23
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _createVNode(_component_el_form_item, { prop: "manufacturer_id" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.vehicle.manufacturer_id,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.vehicle.manufacturer_id) = $event)),
                      filterable: !_ctx.isMobile,
                      placeholder: "Select Car Make",
                      class: "select-input",
                      onChange: _ctx.getModel,
                      "default-first-option": "",
                      "popper-class": {'car_brand_teleport': _ctx.isMobile},
                      onClick: _ctx.alertBrand
                    }, {
                      default: _withCtx(() => [
                        (_ctx.isMobile)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.filtered_brand, (item, index) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                class: "vehicle",
                                key: index,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          : _createCommentVNode("", true),
                        (!_ctx.isMobile)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.manufacturers, (item, index) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                class: "vehicle",
                                key: index,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "filterable", "onChange", "popper-class", "onClick"])
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("label", { ref: "car_model" }, _toDisplayString(_ctx.$t('car_model')) + " * ", 513)
            ])
          ]),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _createVNode(_component_el_form_item, { prop: "model_id" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.vehicle.model_id,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.vehicle.model_id) = $event)),
                      filterable: !_ctx.isMobile,
                      placeholder: "Select Car Model",
                      class: "select-input",
                      onChange: _ctx.getTrimLevel,
                      "default-first-option": "",
                      "popper-class": {'car_model_teleport': _ctx.isMobile},
                      onClick: _ctx.alertModel
                    }, {
                      default: _withCtx(() => [
                        (_ctx.isMobile)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.filtered_model, (item, index) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                class: "vehicle",
                                key: index,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          : _createCommentVNode("", true),
                        (!_ctx.isMobile)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.models, (item, index) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                class: "vehicle",
                                key: index,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "filterable", "onChange", "popper-class", "onClick"])
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("label", { ref: "model_details" }, _toDisplayString(_ctx.$t('model_details')) + " * ", 513)
            ])
          ]),
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _createVNode(_component_el_form_item, { prop: "trim_level_id" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.vehicle.trim_level_id,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.vehicle.trim_level_id) = $event)),
                      filterable: !_ctx.isMobile,
                      placeholder: "Select Model Details",
                      class: "select-input",
                      onChange: _ctx.getEstimatedValues,
                      "default-first-option": "",
                      "popper-class": {'car_trim_teleport': _ctx.isMobile},
                      onClick: _ctx.alertTrim
                    }, {
                      default: _withCtx(() => [
                        (_ctx.isMobile)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.filtered_trim, (item, index) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                class: "bike",
                                key: index,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          : _createCommentVNode("", true),
                        (!_ctx.isMobile)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.trimLevels, (item, index) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                class: "bike",
                                key: index,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "filterable", "onChange", "popper-class", "onClick"])
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_39, [
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("label", { ref: "car_val" }, _toDisplayString(_ctx.$t('estimated_car_value')) + " * ", 513)
            ]),
            _createElementVNode("div", _hoisted_42, [
              _createVNode(_component_el_tooltip, {
                class: "box-item",
                effect: "light"
              }, {
                content: _withCtx(() => [
                  _createElementVNode("p", _hoisted_43, _toDisplayString(_ctx.$t('estimated_car_value_tool_tip')), 1)
                ]),
                default: _withCtx(() => [
                  _hoisted_44
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("div", _hoisted_47, [
                _createVNode(_component_el_form_item, { prop: "car_values" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.vehicle.car_values,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.vehicle.car_values) = $event)),
                      type: "tel",
                      placeholder: _ctx.$t('car_value'),
                      maxlength: "13",
                      pattern: "[0-9]*",
                      oninput: "javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); this.value = this.value.replace(/[^0-9.]/g, '')",
                      onBlur: _ctx.roundtheValue
                    }, {
                      prefix: _withCtx(() => [
                        _createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.$t('AED')), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "placeholder", "onBlur"])
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_49, [
          _createElementVNode("div", _hoisted_50, [
            _createElementVNode("div", _hoisted_51, [
              _createElementVNode("h6", _hoisted_52, [
                _createTextVNode(_toDisplayString(_ctx.$t('estimated_car_value_from')) + " ", 1),
                (Object.keys(_ctx.estimatedValues).length > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_53, _toDisplayString(_ctx.$t('froms')) + " " + _toDisplayString(_ctx.estimatedValues ? _ctx.$filters.currency( _ctx.vehicle.is_new === 1 && _ctx.estimatedValues.new_min ? _ctx.estimatedValues.new_min : _ctx.estimatedValues.old_min, 2) : 0.00) + " " + _toDisplayString(_ctx.$t('to')) + " " + _toDisplayString(_ctx.estimatedValues ? _ctx.$filters.currency(_ctx.vehicle.is_new === 1 && _ctx.estimatedValues.new_max ? _ctx.estimatedValues.new_max : _ctx.estimatedValues.old_max, 2) : 0.00), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('insurance_company_approval')), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_55, [
          _createElementVNode("div", _hoisted_56, [
            _createElementVNode("div", _hoisted_57, [
              _createElementVNode("label", null, _toDisplayString(_ctx.$t('emirates')) + " *", 1)
            ]),
            _createElementVNode("div", _hoisted_58, [
              _createVNode(_component_el_tooltip, {
                class: "box-item",
                effect: "light"
              }, {
                content: _withCtx(() => [
                  _createElementVNode("p", _hoisted_59, _toDisplayString(_ctx.$t('emirates_tool_tip')), 1)
                ]),
                default: _withCtx(() => [
                  _hoisted_60
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_61, [
            _createElementVNode("div", _hoisted_62, [
              _createElementVNode("div", _hoisted_63, [
                _createVNode(_component_el_form_item, { prop: "registration_emirate" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.vehicle.registration_emirate,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.vehicle.registration_emirate) = $event)),
                      filterable: !_ctx.isMobile,
                      class: "select-input",
                      placeholder: `${_ctx.$t('emirates_placeholder')}`,
                      "popper-class": {'emirates_teleport': _ctx.isMobile},
                      onClick: _ctx.alertEmirate
                    }, {
                      default: _withCtx(() => [
                        (_ctx.isMobile)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.filtered_emirates, (item, index) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                class: "vehicle",
                                key: index,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          : _createCommentVNode("", true),
                        (!_ctx.isMobile)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.emirate, (item, index) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                class: "vehicle",
                                key: index,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "filterable", "placeholder", "popper-class", "onClick"])
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_64, [
          _createElementVNode("div", _hoisted_65, [
            _createElementVNode("div", _hoisted_66, [
              _createElementVNode("label", { ref: "full_name" }, _toDisplayString(_ctx.$t('full_name')) + " * ", 513)
            ])
          ]),
          _createElementVNode("div", _hoisted_67, [
            _createElementVNode("div", _hoisted_68, [
              _createElementVNode("div", _hoisted_69, [
                _createVNode(_component_el_form_item, { prop: "name" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.vehicle.name,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.vehicle.name) = $event)),
                      placeholder: `${_ctx.$t('full_name_paceholder')}`,
                      maxlength: "62",
                      onkeydown: _ctx.language === 'en' ? `return /[a-zA-Z_ \s'-]/i.test(event.key)` : ''
                    }, null, 8, ["modelValue", "placeholder", "onkeydown"])
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_70, [
          _createElementVNode("div", _hoisted_71, [
            _createElementVNode("div", _hoisted_72, [
              _createElementVNode("label", { ref: "phone" }, _toDisplayString(_ctx.$t('phone_number')) + " * ", 513)
            ])
          ]),
          _createElementVNode("div", _hoisted_73, [
            _createElementVNode("div", _hoisted_74, [
              _createElementVNode("div", _hoisted_75, [
                _createVNode(_component_el_form_item, { prop: "phone_number" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.vehicle.phone_number,
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.vehicle.phone_number) = $event)),
                      modelModifiers: { number: true },
                      type: "tel",
                      maxlength: "10",
                      pattern: "[0-9]*",
                      placeholder: `${_ctx.$t('phone_number_placeholder')}`,
                      id: "phone_number",
                      disabled: _ctx.disablePhoneNumber || _ctx.disableLqId,
                      oninput: "javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); this.value = this.value.replace(/[^0-9]/g, '')"
                    }, {
                      prefix: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.vehicle.phone_country_code,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.vehicle.phone_country_code) = $event)),
                          filterable: !_ctx.isMobile,
                          placeholder: "",
                          class: "country",
                          disabled: _ctx.disablePhoneNumber || _ctx.disableLqId,
                          "popper-class": {'country_teleport': _ctx.isMobile},
                          onClick: _ctx.alertcountry,
                          onChange: _cache[16] || (_cache[16] = ($event: any) => (_ctx.country_search = ''))
                        }, {
                          default: _withCtx(() => [
                            (_ctx.isMobile)
                              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.filtered_country, (item, index) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: index,
                                    label: item.text,
                                    value: item.text
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              : _createCommentVNode("", true),
                            (!_ctx.isMobile)
                              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.country, (item, index) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: index,
                                    label: item.text,
                                    value: item.text
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["modelValue", "filterable", "disabled", "popper-class", "onClick"])
                      ]),
                      _: 1
                    }, 8, ["modelValue", "placeholder", "disabled"])
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_76, [
          _createElementVNode("div", _hoisted_77, [
            _createElementVNode("div", _hoisted_78, [
              _createElementVNode("label", { ref: "email_address" }, _toDisplayString(_ctx.$t('email')) + " * ", 513)
            ])
          ]),
          _createElementVNode("div", _hoisted_79, [
            _createElementVNode("div", _hoisted_80, [
              _createElementVNode("div", _hoisted_81, [
                _createVNode(_component_el_form_item, { prop: "email" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.vehicle.email,
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.vehicle.email) = $event)),
                      placeholder: `${_ctx.$t('email_placeholder')}`,
                      maxlength: "62",
                      ref: "emailRef",
                      onInput: _cache[19] || (_cache[19] = ($event: any) => (_ctx.isEmailExist = null))
                    }, null, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_82, [
        _createElementVNode("div", _hoisted_83, [
          _createElementVNode("div", _hoisted_84, [
            _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              type: "primary",
              class: "btn",
              onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.handleClick(_ctx.ruleFormRef))),
              "element-loading-background": "rgba(0, 0, 0, 0.4)",
              disabled: _ctx.isClick
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_85, _toDisplayString(_ctx.$t('proceed')), 1)
              ]),
              _: 1
            }, 8, ["disabled"])), [
              [
                _directive_loading,
                _ctx.isClick,
                void 0,
                {
                  fullscreen: true,
                  lock: true
                }
              ]
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["model", "rules"]))
}